import { Button, Stack, useMediaQuery, useTheme, Grid } from "@mui/material";
import React, { useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateFilter = ({ startDate, endDate, onFilter }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [selectedRange, setSelectedRange] = useState(null);

    const handleSelect = (label) => {
        setSelectedRange(label);
        const now = dayjs();
        let newStart = null;
        let newEnd = null;

        switch (label) {
            case "This Year":
                newStart = now.startOf("year").format("YYYY-MM-DD");
                newEnd = now.endOf("year").format("YYYY-MM-DD");
                break;
            case "Last Year":
                newStart = now.subtract(1, "year").startOf("year").format("YYYY-MM-DD");
                newEnd = now.subtract(1, "year").endOf("year").format("YYYY-MM-DD");
                break;
            case "This Month":
                newStart = now.startOf("month").format("YYYY-MM-DD");
                newEnd = now.endOf("month").format("YYYY-MM-DD");
                break;
            case "Last Month":
                newStart = now.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
                newEnd = now.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
                break;
            default:
                return;
        }

        onFilter?.({ startDate: newStart, endDate: newEnd });
    };

    const handleDateChange = (type, date) => {
        const newDate = date ? date.format("YYYY-MM-DD") : "";
        if (type === "start") {
            onFilter?.({ startDate: newDate, endDate });
        } else {
            onFilter?.({ startDate, endDate: newDate });
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack direction={isMobile ? "column" : "row"} spacing={2} alignItems={isMobile ? "stretch" : "center"} sx={{ mt: 1 }}>
                {/* Start Date */}
                <DatePicker
                    value={startDate ? dayjs(startDate) : null}
                    onChange={(date) => handleDateChange("start", date)}
                    slotProps={{
                        textField: {
                            size: "medium", fullWidth: true, sx: {
                                "& .MuiPickersSectionList-sectionContent": {
                                    fontSize: "14px",
                                    lineHeight: "1.2",
                                },
                            },
                            InputLabelProps: {
                                sx: {
                                    fontSize: "14px",
                                },
                            },
                            size: "small",
                            label: "Date From",
                            variant: "outlined",
                            sx: { minWidth: 140 }
                        }
                    }}
                />

                {/* End Date */}
                <DatePicker
                    value={endDate ? dayjs(endDate) : null}
                    onChange={(date) => handleDateChange("end", date)}
                    slotProps={{
                        textField: {
                            size: "medium", fullWidth: true, sx: {
                                "& .MuiPickersSectionList-sectionContent": {
                                    fontSize: "14px",
                                    lineHeight: "1.2",
                                },
                            },
                            InputLabelProps: {
                                sx: {
                                    fontSize: "14px",
                                },
                            },
                            size: "small",
                            label: "Date To",
                            variant: "outlined",
                            sx: { minWidth: 140 }
                        }
                    }}
                />

                {/* Quick Buttons */}
                {["This Year", "Last Year", "This Month", "Last Month"].map((label) => (
                    <Button
                        key={label}
                        size="medium"
                        variant={selectedRange === label ? "contained" : "outlined"}
                        sx={{ minWidth: 110, textTransform: "none" }}
                        onClick={() => handleSelect(label)}
                    >
                        {label}
                    </Button>
                ))}
            </Stack>
        </LocalizationProvider>
    );
};

export default DateFilter;